import { lazy } from 'react';

const MyTasksApp = lazy(() => import('./MyTasksApp'));

const MyTasksAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  helpConfig: {
    query: 'my tasks personal',
    tag: 'tasks',
    title: 'My Tasks'
  },
  routes: [
    {
      path: '/apps/my-tasks',
      element: <MyTasksApp />,
    },
  ],
};

export default MyTasksAppConfig;